const isProdEnv = process.env.REACT_APP_ENV === "production";
//TO DO remove afte prod check
//edit captcha keys for other env
const reCaptchaDevKey = "6LchgpIUAAAAAKfkLiHA7v-VflGzVZQ8QKeZa6M6";
const reCaptchaProdKey = "6LdKy5IUAAAAADqIEN9c30vQQa0oVLBayrXW_qNj";

const reCaptchaKey = isProdEnv ? reCaptchaProdKey : reCaptchaDevKey;
//recaptcha for locallhost
//const reCaptchaKey = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'

const downloadLinks = {
  ios: "https://itunes.apple.com/us/app/healo/id1365513955#?platform=iphone",
  android: "https://play.google.com/store/apps/details?id=com.empowered.healo"
};

const phoneRegex = /Android|iPhone|Opera Mini/i;

const instruction = "instruction";
const information = "information";
const appLanguages = {
  en: "en",
  sv: "sv",
  is: "is"
};
const consentText = `<p>
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Praesent
        dapibus. Fusce aliquam vestibulum ipsum. Aliquam id dolor. Maecenas
        lorem. Ut tempus purus at lorem. Ut enim ad minim veniam, quis nostrud
        exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
        Duis bibendum, lectus ut viverra rhoncus, dolor nunc faucibus libero,
        eget facilisis enim ipsum id lacus. Vestibulum fermentum tortor id mi.
        Curabitur vitae diam non enim vestibulum interdum. Suspendisse sagittis
        ultrices augue. Quisque porta.
      </p>`;

const weightValidation = {
  min: 30,
  max: 250
};

const heightValidation = {
  min: 100,
  max: 230
};

const diagnosisColouringRules = {
  redFlag: {
    key: "_rf",
    title: "self-diagnostic.finished",
    text: "diagnosis_finished.text_rf",
    textExtended: "diagnosis_finished.text_rf_extended",
    colour: "#ff0000"
  },
  orangeFlag: {
    key: "_of",
    title: "self-diagnostic.finished",
    text: "diagnosis_finished.text_of",
    textExtended: "diagnosis_finished.text_of_extended",
    colour: "#ffa500"
  },
  yellowFlagLong: {
    key: "_l_yf",
    title: "self-diagnostic.finished",
    text: "diagnosis_finished.text_l_yf",
    textExtended: "diagnosis_finished.text_l_yf_extended",
    colour: "#f2f20e"
  },
  yellowFlagQuick: {
    key: "_q_yf",
    title: "self-diagnostic.finished_q_yf",
    text: "diagnosis_finished.text_q_yf",
    textExtended: "diagnosis_finished.text_q_yf_extended",
    colour: "#f2f20e"
  },
  default: {
    key: "",
    title: "self-diagnostic.finished",
    text: "diagnosis_finished.text_default",
    textExtended: "diagnosis_finished.text_default_extended",
    colour: ""
  }
};

const clinics = [
  { label: "HMC Landskrona", value: "HMC Landskrona" },
  { label: "HMC Lomma", value: "HMC Lomma" },
  { label: "HMC Staffanstorp", value: "HMC Staffanstorp" },
  { label: "HMC Hjärup", value: "HMC Hjärup" },
  { label: "HMC Företagshälsovård", value: "HMC Företagshälsovård" }
];

const LoginMethod = {
  BankId: "bank-id",
  Email: "email"
};

const SEX = {
  MALE: "male",
  FEMALE: "female"
};

const COLLECT_SEX_MAP = {
  m: SEX.MALE,
  f: SEX.FEMALE
};

const BACKEND_SWEDISH_LANG_CODE = "swe";

// const phoneRegex = /Android|iPhone|iPad|iPod|Opera Mini/i;
export default {
  downloadLinks,
  phoneRegex,
  instruction,
  information,
  appLanguages,
  consentText,
  reCaptchaKey,
  weightValidation,
  heightValidation,
  diagnosisColouringRules,
  clinics,
  LoginMethod,
  BACKEND_SWEDISH_LANG_CODE,
  SEX,
  COLLECT_SEX_MAP
};



// WEBPACK FOOTER //
// ./src/common/constants.js